import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export const graphActionToolbarUiEvents = eventGroup({
  source: 'Modeler Graph Action Toolbar UI',
  events: {
    addToFrameClicked: type<void>(),
  },
});
